// extracted by mini-css-extract-plugin
module.exports = {"section_partner":"events_section_partner__6Q0_W","find_uni_root":"events_find_uni_root__Hf3lq","form_wrapper":"events_form_wrapper__n5tdo"};